<script>
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default {
  name: "DateInput",
  props: {
    modelValue: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'D'
    },
    mb: {
      type: Number,
      default: 3
    },
  },
  emits: ['update:modelValue'],
  methods: {
    updateValue(event) {
      let value = event.target.value

      if (value.length === 4 && !value.includes('.')) {
        const date = dayjs(value, 'DDMM', true)
        if (date.isValid())
          value = event.target.value = date.format('DD.MM.YYYY');
      }

      this.$emit('update:modelValue', event.target.value);
    },
    setCurrentTime() {
      this.$emit('update:modelValue', dayjs().format('DD.MM.YYYY'));
    }
  }
}
</script>

<template>
  <div :class="'input-group mb-'+ mb + (!fullWidth ? ' col-4 w55 pl-0' : '' )">
    <div class="input-group-prepend">
      <label
          :for="inputId"
          class="input-group-text pointer"
          style="min-width:auto"
          @click.prevent="setCurrentTime">{{ label }}</label>
    </div>
    <input
        :id="inputId"
        :value="modelValue"
        class="form-control form-control-lg"
        placeholder="TTMM / TT.MM.JJJJ"
        pattern="(?:\d{4}|\d{1,2}\.\d{1,2}\.\d{4})"
        @input="updateValue"/>
  </div>
</template>

<style scoped>

</style>